export default __webpack_public_path__ + "static/media/paper.3a1eeed6.png";